import cn from 'classnames';
import styles from './helper-text.module.scss';

interface Props {
  name?: string;
  text?: string;
  hasError?: boolean;
}
export const HelperText = ({ text, name = '', hasError }: Props) => {
  return (
    <span
      id={`helper-text-${name}`}
      data-testid="helper-text"
      className={cn(styles['helper-text'], hasError && styles['error'])}
    >
      {text}
    </span>
  );
};
